import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between align-center" }
const _hoisted_2 = { class: "d-flex align-center ga-2 py-2" }
const _hoisted_3 = { class: "d-flex align-center ga-2" }
const _hoisted_4 = { class: "font-size-12-600 pb-2" }

import { computed } from "vue";
import Icon from "@/components/Icons/Icon.vue";
import moment from "moment";
import { formatNotificationDate } from "@/components/Helpers/NotificationHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderNotificationCard',
  props: {
  notification: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const getDate = computed(() => {
  return moment(props.notification.created_at).format("h:mm A");
});

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "font-size-12-400 card-container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, [
            _createVNode(Icon, {
              color: "primaryColor",
              icon: "bell-icon"
            })
          ]),
          _createElementVNode("p", null, _toDisplayString(__props.notification.subject), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", null, _toDisplayString(getDate.value), 1),
          _createElementVNode("p", {
            class: "pa-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close', __props.notification)))
          }, [
            _createVNode(Icon, {
              color: "grey_light",
              icon: "cross-icon"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(formatNotificationDate)(__props.notification.content)), 1)
    ]),
    _: 1
  }))
}
}

})